import React, { useState } from 'react';
import { Divider } from '@telus-uds/components-web';

import TabSelection from './tabSelection';
import CouponCodes from './couponCodes';
import DeviceMatrix from './deviceMatrix';

const BCON = () => {
  const [selectedTab, setSelectedTab] = useState('COUPON_CODES');

  const tabComponents = {
    COUPON_CODES: <CouponCodes />,
    DEVICE_MATRIX: <DeviceMatrix />,
  };

  return (
    <>
      <TabSelection selectedTab={selectedTab} setSelectedTab={setSelectedTab} />
      <Divider space={1} variant={{ inverse: true }} />
      {tabComponents[selectedTab]}
    </>
  );
};

export default BCON;
